/* Coffee Description
   Read-more behavior for the origin story and tap support for profile tooltips. */
(function () {
  'use strict';

  var SECTION = '[data-coffee-description]';

  function initStory(root) {
    var story = root.querySelector('[data-cd-story]');
    var button = root.querySelector('[data-cd-more]');
    if (!story || !button) return;

    var inner = story.querySelector('[data-cd-story-inner]');
    if (!inner) return;

    if (button.getAttribute('aria-expanded') !== 'true') {
      story.classList.add('is-clamped');
      var overflows = inner.scrollHeight - inner.clientHeight > 2;
      button.hidden = !overflows;
      if (!overflows) story.classList.remove('is-clamped');
    }

    if (button.dataset.cdBound === 'true') return;
    button.dataset.cdBound = 'true';

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      story.classList.toggle('is-clamped', expanded);
      button.textContent = expanded
        ? button.dataset.cdMoreText || 'Read more'
        : button.dataset.cdLessText || 'Read less';
    });
  }

  function initTips(root) {
    root.querySelectorAll('[data-cd-tip]').forEach(function (tip) {
      if (tip.dataset.cdBound === 'true') return;
      tip.dataset.cdBound = 'true';

      tip.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = tip.classList.contains('is-open');
        closeTips(root);
        tip.classList.toggle('is-open', !open);
      });

      tip.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') tip.classList.remove('is-open');
      });

      tip.addEventListener('blur', function () {
        tip.classList.remove('is-open');
      });
    });
  }

  function closeTips(root) {
    root.querySelectorAll('[data-cd-tip].is-open').forEach(function (tip) {
      tip.classList.remove('is-open');
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll(SECTION).forEach(function (root) {
      initStory(root);
      initTips(root);
    });
  }

  function onDocumentClick() {
    document.querySelectorAll(SECTION).forEach(closeTips);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('click', onDocumentClick);
  window.addEventListener('resize', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    closeTips(event.target);
  });
})();
